import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-title" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { class: "trezo-card-content" }
const _hoisted_6 = { class: "mb-[12px] last:mb-0" }
const _hoisted_7 = { class: "text-black dark:text-white font-medium" }
const _hoisted_8 = { class: "mb-[12px] last:mb-0" }
const _hoisted_9 = { class: "text-black dark:text-white font-medium" }
const _hoisted_10 = { class: "mb-[12px] last:mb-0" }
const _hoisted_11 = { class: "text-black dark:text-white font-medium" }
const _hoisted_12 = { class: "mb-[12px] last:mb-0" }
const _hoisted_13 = { class: "text-black dark:text-white font-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.directT('ecommerce.orderDetails.billingDetails')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.directT('ecommerce.orderDetails.name')) + ": ", 1),
          _createTextVNode(" " + _toDisplayString(_ctx.order?.name || 'N/A'), 1)
        ]),
        _createElementVNode("li", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.directT('ecommerce.orderDetails.email')) + ": ", 1),
          _createTextVNode(" " + _toDisplayString(_ctx.order?.email || 'N/A'), 1)
        ]),
        _createElementVNode("li", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.directT('ecommerce.orderDetails.phone')) + ": ", 1),
          _createTextVNode(" " + _toDisplayString(_ctx.order?.phone || 'N/A'), 1)
        ]),
        _createElementVNode("li", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.directT('ecommerce.orderDetails.address')) + ": ", 1),
          _createTextVNode(" " + _toDisplayString(_ctx.order?.address || 'N/A'), 1)
        ])
      ])
    ])
  ]))
}